export default __webpack_public_path__ + "static/media/bun-bo-nam-bo.be77106d.jpg";